export const AddressMessages = {
  city: 'Stad',
  connection: 'Aansluitadres',
  houseNumber: 'Huisnummer',
  houseNumberAddition: 'Huisnummer toevoeging',
  postalCode: 'Postcode',
  street: 'Straat',
};
